import axios from './axiosService';

export default {
  getSnippet(snippetID) {
    return axios.get(`/api/snippets/${snippetID}`)
      .then(response => response.data);
  },
  getSnippets(params = {}) {
    const options = {
      params,
    }
    return axios.get(`/api/snippets`, options)
      .then(response => response.data);
  },
  create(form) {
    return form.post(`/api/snippets`)
      .then(response => response.data);
  },
  update(snippetID, form) {
    return form.put(`/api/snippets/${snippetID}`)
      .then(response => response.data);
  },
  delete(snippetID) {
    return axios.delete(`/api/snippets/${snippetID}`)
      .then(response => response.data);
  }
}
